module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_ar-areas-of-application_792-352-1-886bf7b23da73d75dcd7a6ea4aa2c2b3.jpg";